import { render, staticRenderFns } from "./icon-template.vue?vue&type=template&id=a984eb56&scoped=true&"
import script from "./icon-template.vue?vue&type=script&lang=js&"
export * from "./icon-template.vue?vue&type=script&lang=js&"
import style0 from "./icon-template.vue?vue&type=style&index=0&id=a984eb56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a984eb56",
  null
  
)

export default component.exports